import type { Observable } from "rxjs";

/**
 * A wrapper object used with API fetch requests to easily communicate loading and failure to templates.
 */
 export interface LoadData<T> {
	loading: boolean;
	error?: string;
	data?: T;
}

export type Load<T> = Observable<LoadData<T>>

/**
 * All Elastic Search service results have this structure.
 */
 export interface Page<ItemType> {
	items?: ItemType[];
	offset?: number;
	limit?: number;
	total: number;
}

export interface APIError {
	error_code: string;
	friendly_message: string;
	developer_message: string;

	// the following are scarcely returned
	title?: string;
	message?: string;
	error_message?: string;
	http_response_code?: number;
	trace_id?: string;

	// incase the API does not respond with a JSON object
	text?: string;
}

/**
 * HTTP error response
 */
export class HTTPError {
	http_response_code: number;
	error_code: string;
	error_message: string;
	friendly_message: string;

	constructor(props: {
		http_response_code: number,
		error_code: string,
		error_message: string,
		friendly_message: string,
	}) {
		this.http_response_code = props.http_response_code;
		this.error_code = props.error_code,
		this.error_message = props.error_message;
		this.friendly_message = props.friendly_message;
	}
}
